module.exports = __webpack_public_path__ + "static/img/1.e99a960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/1.png
// module id = Q3yA
// module chunks = 2